<template>
  <form @submit.prevent="saveProfile"
        class="fieldset profile-center">
    <div class="fieldset-wrap"  @click="formEdit">
      <h3 class="legend">{{$t('profile.infoTitle')}}</h3>
      <label :class="{'disabled-input': !edited, 'input-cont_small': edited, 'error': $v.nameVal.$error}">
        <p class="label">{{$t('forms.nameLb')}}</p>
        <input :readonly="!edited"
               :disabled="!edited"
               @change="setDirt"
               @blur="$v.nameVal.$touch()"
               @focus="$v.nameVal.$reset()"
               v-model="nameVal">
        <errors v-show="$v.nameVal.$error"></errors>
      </label>
      <label :class="{'disabled-input': !edited, 'input-cont_small': edited}">
        <p class="label">{{$t('forms.surnameLb')}}</p>
        <input :readonly="!edited"
               @change="setDirt"
               :disabled="!edited"
               v-model="surnameVal">
      </label>
      <label :class="{'disabled-input': !edited, 'input-cont_small': edited, 'error': $v.mailVal.$error}">
        <p class="label">{{$t('forms.emailLb')}}</p>
        <input :readonly="!edited"
               :disabled="!edited"
               @change="setDirt"
               @blur="$v.mailVal.$touch()"
               @focus="$v.mailVal.$reset()"
               v-model="mailVal">
        <errors v-show="$v.mailVal.$error" type="mail"></errors>
      </label>
      <label  :class="{'disabled-input': !edited, 'input-cont_small': edited}">
        <p class="label">{{$t('forms.telLb')}}</p>
        <div class="phone-cont">
          <phone-codes v-if="edited" :active-default="telVal"></phone-codes>
          <input v-mask="activeCode.code + ' ' + activeCode.mask"
                 :class="{'phone-input': edited}"
                 @change="setDirt"
                 :readonly="!edited"
                 :disabled="!edited"
                 @keypress="delString"
                 v-model="telVal">
        </div>
      </label>
    </div>
    <div class="fieldset-wrap"  @click="formEdit">
      <h3 class="legend">{{$t('profile.dopTitle')}}</h3>
      <label :class="{'disabled-input': !edited, 'input-cont_small': edited}">
        <p class="label">{{$t('forms.searchAddressLb')}}</p>
        <!--<gmap-autocomplete :readonly="!edited"-->
                           <!--:placeholder="$t('forms.searchAddressPl')"-->
                           <!--@place_changed="setAddress"-->
                           <!--:value="addressVal"-->
                           <!--:disabled="!edited"></gmap-autocomplete>-->
        <input v-model="addressVal"
               :readonly="!edited"
               :placeholder="$t('forms.searchAddressPl')"
               :disabled="!edited"
               @change="setDirt">
      </label>
      <label :class="{'disabled-input': !edited, 'input-cont_small': edited}">
        <p class="label">{{$t('forms.postalCodeLb')}}</p>
        <input v-model="postalVal"
               @change="setDirt"
               :redonly="!edited"
               :placeholder="$t('forms.postalCodePl')"
               :disabled="!edited">
      </label>
      <label :class="{'disabled-input': !edited, 'input-cont_small': edited}">
        <p class="label">{{$t('forms.cityLb')}}</p>
        <input :readonly="!edited"
               :disabled="!edited"
               @change="setDirt"
               :placeholder="$t('forms.cityLb')"
               v-model="cityVal">
        <!--<errors v-show="$v.cityVal.$error"></errors>/-->
      </label>
      <label :class="{'disabled-input': !edited, 'input-cont_small': edited}">
        <p class="label">{{$t('forms.provinceLb')}}</p>
        <input :readonly="!edited"
               :disabled="!edited"
               @change="setDirt"
               :placeholder="$t('forms.provinceLb')"
               v-model="regionVal">
        <!--<errors v-show="$v.regionVal.$error"></errors>-->
      </label>
      <label :class="{'disabled-input': !edited, 'input-cont_small': edited}">
        <p class="label">{{$t('forms.countryLb')}}</p>
        <input :readonly="!edited"
               :disabled="!edited"
               @change="setDirt"
               :placeholder="$t('forms.countryLb')"
               v-model="countryVal">
        <!--<errors v-show="$v.countryVal.$error"></errors>-->
      </label>
      <div :class="{'disabled-select disabled-input': !edited, 'select-cont': edited}">
        <p class="label">{{$t('forms.lang')}}</p>
        <v-select :clearable="false"
                  :searchable="false"
                  :filterable="false"
                  :close-on-select="true"
                  :select-on-tab="edited"
                  @change="setDirt"
                  v-model="languageVal"
                  @input="changeLang"
                  :disabled="!edited"
                  :options="['Русский', 'English']"></v-select>

        <!--<input  :readonly="!edited"-->
                <!--@keypress="delNumbers"-->
                <!--@blur="$v.languageVal.$touch()"-->
                <!--@focus="$v.languageVal.$reset()"-->
                <!--:disabled="!edited"-->
                <!--v-model="languageVal">-->
        <!--<errors v-show="$v.languageVal.$error"></errors>-->
      </div>
    </div>
    <button type="submit"
            :class="{'loading': loading}"
            class="btn btn-transparent_dark"
            :disabled="!edited || $v.$anyError || loading">
      {{$t('btns.save')}}
    </button>
  </form>
</template>

<script>
  import {validate} from "../../../mixins/utils/validate";
  import {email, required, minLength} from 'vuelidate/lib/validators'
  import {toFormData} from "../../../mixins/utils/toFormData";
  import {phoneCode} from "../../../mixins/utils/phoneCode";

  import errors from '../../Forms/errors'

  import {createNamespacedHelpers} from 'vuex'
  const {mapState} = createNamespacedHelpers('profile');
  const {mapMutations} = createNamespacedHelpers('profile');
  const {mapActions} = createNamespacedHelpers('profile');

  export default {
    name: 'profileCenter',
    props: {
      edited: {
        type: Boolean,
        default: false
      }
    },
    mixins: [validate, phoneCode, toFormData],
    components: {
      errors
    },
    data() {
      return {
        loading: false
      }
    },
    computed: {
      ...mapState([
        'name',
        'surname',
        'mail',
        'tel',
        'city',
        'region',
        'country',
        'language',
        'postalCode',
        'avatar',
        'validCenter',
        'photoUpload',
        'address'
      ]),
      addressVal: {
        get() {
          return this.address
        },
        set(val) {
          this.SET_ADDRESS(val)
        }
      },
      nameVal: {
        get() {
          return this.name
        },
        set(val) {
          this.SET_NAME(val)
        }
      },
      surnameVal: {
        get() {
          return this.surname
        },
        set(val) {
          this.SET_SURNAME(val)
        }
      },
      mailVal: {
        get() {
          return this.mail
        },
        set(val) {
          this.SET_MAIL(val)
        }
      },
      telVal: {
        get() {
          return this.tel
        },
        set(val) {
          this.SET_TEL(val)
        }
      },
      cityVal: {
        get() {
          return this.city
        },
        set(val) {
          this.SET_CITY(val)
        }
      },
      regionVal: {
        get() {
          return this.region
        },
        set(val) {
          this.SET_REGION(val)
        }
      },
      countryVal: {
        get() {
          return this.country
        },
        set(val) {
          this.SET_COUNTRY(val)
        }
      },
      languageVal: {
        get() {
          return this.language
        },
        set(val) {
          switch (val) {
            case('RU'): {
              this.SET_LANGUAGE('Русский');
            };
              break;
            case('EN'): {
              this.SET_LANGUAGE('English')
            };
              break;
            default: this.SET_LANGUAGE(val);
              break;
          }
        }
      },
      postalVal: {
        get() {
          return this.postalCode
        },
        set(val) {
          this.SET_POSTAL_CODE(val)
        }
      }

    },
    validations: {
      nameVal: {
        required
      },
      mailVal: {
        required,
        email
      },
      languageVal: {
        required
      }
    },
    methods: {
      ...mapMutations([
        'SET_NAME',
        "SET_SURNAME",
        "SET_MAIL",
        "SET_TEL",
        "SET_CITY",
        "SET_REGION",
        "SET_COUNTRY",
        "SET_LANGUAGE",
        "SET_VALID_CENTER",
        "SET_POSTAL_CODE",
        "SET_ADDRESS",
        "SET_DIRT"
      ]),
      ...mapActions([
        'updateUser'
      ]),
      setLang(lang) {
        localStorage.setItem('lang', lang);
        this.$i18n.locale = lang
      },
      changeLang() {
        let val = this.languageVal;
        switch (val) {
          case ('Русский'): this.setLang('ru');
            break;
          case ('English'): this.setLang('en');
            break;
          default: this.setLang(val);
            break;
        }
      },
      setDirt() {
        this.SET_DIRT(true);
      },
      formEdit() {
        this.$emit('formEdit')
      },
      saveProfile() {
        const token = localStorage.getItem('token');

        this.loading = true;
        let data = {
          first_name: this.name,
          second_name: this.surname,
          email: this.mail,
          language: this.$i18n.locale.toUpperCase(),
          zip: this.postalCode,
          address: this.addressVal,
          phone: this.tel ? this.tel : '',
          region: this.region,
          city: this.city,
          country: this.country,
        };
        let formData = this.toFormData(data)
        formData.append('avatar', this.photoUpload);
        this.updateUser(formData).then((res) => {
          this.loading = false;
          this.$emit('disableEdited');
          this.SET_DIRT(false);
        }).catch((e) => {
          this.loading = false;
        })

      }
    },
    updated() {
      if (this.$v.$anyError) {
        this.SET_VALID_CENTER(false)
      } else {
        this.SET_VALID_CENTER(true)
      };

      let lang = this.language;
      if (lang && lang != null) {
        switch (lang) {
          case ('RU'):
            this.languageVal = 'Русский';
            break;
          case('EN'):
            this.languageVal = 'English';
            break;
        }
      }
    },
    mounted() {
      this.SET_DIRT(false);
    }
  }
</script>

<style lang="scss" scoped>
.profile-center {
  padding: 10px 40px 0;
  border-left: 1px solid $lightGrey;
  border-right: 1px solid $lightGrey;
  width: 50%;
  height: 100%;
}

input {
  width: 100%;

  &::placeholder {
    color: $darkBlue;
  }
}

  label {
    margin-bottom: 25px;
  }

  .btn {
    margin-top: 20px;
  }
</style>
